module.exports = __webpack_public_path__ + "assets/img/en-6882bb5d.png";